import { formatBusinessType, formatOrganizationName } from "../../domain/account/organizationDetails";

export { formatBusinessType, formatOrganizationName };

// Capitalize first letter of a name
export const capitalizeName = (name?: string): string => {
  if (!name) return "";
  const trimmed = name.trim();
  if (trimmed.length === 0) return "";
  return trimmed.charAt(0).toUpperCase() + trimmed.slice(1).toLowerCase();
};

// Format email to show organization name instead of orgId
export const formatEmail = (
  email?: string,
  orgId?: string,
  soid?: string
): string => {
  if (!email) return "";
  if (!email.includes("@")) return email;

  const [username, domain] = email.split("@");

  if (soid && orgId) {
    const normalizedDomain = domain.toLowerCase().replace(/-/g, "");
    const normalizedOrgId = orgId.toLowerCase().replace(/-/g, "");

    if (
      normalizedDomain === normalizedOrgId ||
      domain.toLowerCase() === orgId.toLowerCase()
    ) {
      return `${username}@${soid}`;
    }
  }

  if (orgId && domain.toLowerCase() === orgId.toLowerCase()) {
    const formattedOrgName = formatOrganizationName(orgId)
      .toLowerCase()
      .replace(/\s+/g, "");
    return `${username}@${formattedOrgName}`;
  }

  return email;
};
